import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { filterActive: Boolean }
  static targets = ["filterContainer", "filterToggleButton"]

  connect() {
    this.filterVisible = this.hasFilterContainerTarget
      ? this.filterContainerTarget.classList.contains("show")
      : false
    this.refreshFilterButton()
  }

  handleFormSubmit(event) {
    if (event.target.id === "property_manager_searchform") {
      const formData = new FormData(event.target)
      const ignoredFields = ["clear", "property_group_id", "authenticity_token", "commit"]
      let hasActiveFilters = formData.get("clear") !== "1" && (() => {
        for (const [key, value] of formData.entries()) {
          if (ignoredFields.includes(key)) continue
          const normalized = typeof value === "string" ? value.trim() : value
          if (normalized !== "" && normalized !== "0" && normalized != null) return true
        }
        return false
      })()

      this.filterActiveValue = hasActiveFilters
      this.refreshFilterButton()
    }
  }

  filterActiveValueChanged() {
    this.refreshFilterButton()
  }

  toggleFilter(event) {
    event?.preventDefault()
    if (this.hasFilterContainerTarget) {
      this.filterContainerTarget.classList.toggle("show")
      this.filterVisible = this.filterContainerTarget.classList.contains("show")
      this.refreshFilterButton()
    }
  }

  refreshFilterButton() {
    if (!this.hasFilterToggleButtonTarget) return

    const button = this.filterToggleButtonTarget
    const icon = button.querySelector("i")
    const isVisible = this.filterVisible ?? false

    button.classList.toggle("btn-primary", isVisible)
    button.classList.toggle("btn-outline-secondary", !isVisible)

    if (icon) {
      icon.className = this.filterActiveValue ? "bi bi-funnel-fill" : "bi bi-funnel"
    }
  }
}
